module.exports = __webpack_public_path__ + "2e6651dd417e0f4252296347a27693a4.MP3";